import React from "react";

import Paragraph from "@common/components/Paragraph/Paragraph";

import * as Styled from "./OverlayText.styles";

interface OverlayTextProps {
  text?: React.ReactNode;
}

const OverlayText: React.FC<OverlayTextProps> = ({ text }) => {
  if (!text) {
    return null;
  }
  return (
    <Styled.OverlayContainer>
      <span>
        <Styled.StyledInfoIcon />
        <Paragraph p2>{text}</Paragraph>
      </span>
    </Styled.OverlayContainer>
  );
};

export default OverlayText;
